import { useState, useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { api } from "../lib/api";
import { SUPPORTED_CURRENCIES, formatCurrency } from "../contexts/FxContext";
import { DEFAULT_CURRENCY } from "../lib/defaultCurrency";
import { Loader2, Check } from "lucide-react";
import { toast } from "sonner";

export function DisplayCurrencyTile() {
    const { user, refreshMe } = useAuth();
    const [current, setCurrent] = useState(user?.display_currency || DEFAULT_CURRENCY);
    const [busy, setBusy] = useState(false);

    useEffect(() => { setCurrent(user?.display_currency || DEFAULT_CURRENCY); }, [user?.display_currency]);

    const save = async (code) => {
        try {
            setBusy(true);
            await api.patch("/users/me", { display_currency: code });
            setCurrent(code);
            await refreshMe();
            toast.success(`Display currency set to ${code}`);
        } catch (e) { toast.error(e.response?.data?.detail || e.message); }
        finally { setBusy(false); }
    };

    return (
        <div className="surface p-5" data-testid="display-currency-tile">
            <h3 className="font-heading text-lg">Display currency</h3>
            <p className="text-xs text-white/55 mt-1 max-w-md">All pool amounts are stored and processed in their native currency. This setting controls the secondary "≈" conversion shown across the app.</p>
            <div className="mt-4 grid grid-cols-3 sm:grid-cols-5 gap-2">
                {SUPPORTED_CURRENCIES.map((code) => (
                    <button
                        key={code}
                        onClick={() => save(code)}
                        disabled={busy}
                        className={`rounded-md border px-3 py-2 text-xs font-semibold transition-colors inline-flex items-center justify-center gap-1.5 ${
                            current === code ? "border-[#00BF0D]/35 bg-[#00BF0D]/8 text-[#00BF0D]" : "border-white/[0.08] bg-white/[0.025] text-white/75 hover:text-white hover:bg-white/[0.05]"
                        }`}
                        data-testid={`currency-${code}`}
                    >
                        {current === code && <Check className="h-3 w-3" />}
                        {formatCurrency(1, code, { decimals: 0 }).replace(/[\d,.\s]/g, "")} {code}
                    </button>
                ))}
            </div>
            {busy && <Loader2 className="h-3.5 w-3.5 animate-spin text-white/40 mt-2" />}
        </div>
    );
}
